export default __webpack_public_path__ + "static/img-2-11b3eb2f2abcf1b7ab03a209a1b4d44b.png";